import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { NotificationsActions } from './notifications.actions';
import { NotificationsState } from './notifications.state';

export const initSettingsState: NotificationsState = {
  notifications: false,
  email: null,
  loading: false,
  loaded: false,
  centralMailState: {
    data: null,
    loading: false,
    loaded: false,
    dataPresent: false,
    errorGET: null,
    errorPOST: null,
    errorPUT: null,
    errorDELETE: null,
  },
  notificationRecipientsState: {
    data: null,
    loading: false,
    loaded: false,
    dataPresent: false,
    errorGET: null,
    errorPUT: null,
  },
};

export const notificationsReducer: ActionReducer<NotificationsState, Action> = createReducer(
  initSettingsState,

  on(
    NotificationsActions.getMailSubscription,
    (): NotificationsState => ({
      ...initSettingsState,
      loading: true,
    })
  ),

  on(
    NotificationsActions.getMailSubscriptionSuccess,
    (state, { notifications, email }): NotificationsState => ({
      ...state,
      notifications,
      email,
      loading: false,
      loaded: true,
    })
  ),

  on(
    NotificationsActions.getMailSubscriptionError,
    (state): NotificationsState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  ),

  on(
    NotificationsActions.setMailSubscription,
    (state): NotificationsState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    NotificationsActions.setMailSubscriptionSuccess,
    (state, { notifications }): NotificationsState => ({
      ...state,
      notifications,
      loading: false,
    })
  ),

  on(
    NotificationsActions.setMailSubscriptionError,
    (state): NotificationsState => ({
      ...state,
      loading: false,
    })
  ),

  // Central Email

  on(
    NotificationsActions.getCentralEmail,
    (state): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: state.centralMailState.data,
        loading: true,
        loaded: false,
        dataPresent: false,
        errorGET: null,
      },
    })
  ),

  on(
    NotificationsActions.getCentralEmailSuccess,
    (state, { data }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: data.data,
        loading: false,
        loaded: true,
        dataPresent: true,
        errorGET: null,
      },
    })
  ),

  on(
    NotificationsActions.getCentralEmailError,
    (state, { error }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: state.centralMailState.data,
        loading: false,
        loaded: true,
        dataPresent: !!state.centralMailState.data,
        errorGET: error,
      },
    })
  ),

  on(
    NotificationsActions.getCentralEmailNoEmailFound,
    (state): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: null,
        loading: false,
        loaded: true,
        dataPresent: true,
        errorGET: null,
      },
    })
  ),

  on(
    NotificationsActions.setCentralEmailSuccess,
    (state, { data }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: data.data,
        errorPOST: null,
      },
    })
  ),

  on(
    NotificationsActions.setCentralEmailError,
    (state, { error }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        errorPOST: error,
      },
    })
  ),

  on(
    NotificationsActions.updateCentralEmailSuccess,
    (state, { data }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: data.data,
        errorPUT: null,
      },
    })
  ),

  on(
    NotificationsActions.updateCentralEmailError,
    (state, { error }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        errorPUT: error,
      },
    })
  ),

  on(
    NotificationsActions.deleteCentralEmailSuccess,
    (state): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        data: null,
        errorDELETE: null,
      },
    })
  ),

  on(
    NotificationsActions.deleteCentralEmailError,
    (state, { error }): NotificationsState => ({
      ...state,
      centralMailState: {
        ...state.centralMailState,
        errorDELETE: error,
      },
    })
  ),

  on(
    NotificationsActions.getNotificationRecipients,
    (state): NotificationsState => ({
      ...state,
      notificationRecipientsState: {
        ...state.notificationRecipientsState,
        loading: true,
        loaded: false,
        dataPresent: false,
        errorGET: null,
      },
    })
  ),

  on(
    NotificationsActions.getNotificationRecipientsSuccess,
    (state, { data }): NotificationsState => ({
      ...state,
      notificationRecipientsState: {
        ...state.notificationRecipientsState,
        data,
        loading: false,
        loaded: true,
        dataPresent: true,
        errorGET: null,
      },
    })
  ),

  on(
    NotificationsActions.getNotificationRecipientsError,
    (state, { error }): NotificationsState => ({
      ...state,
      notificationRecipientsState: {
        ...state.notificationRecipientsState,
        data: state.notificationRecipientsState.data,
        loading: false,
        loaded: true,
        dataPresent: !!state.notificationRecipientsState.data,
        errorGET: error,
      },
    })
  ),

  on(
    NotificationsActions.updateNotificationRecipient,
    (state, { isActive, recipient }): NotificationsState => {
      const newData = state.notificationRecipientsState.data.map((entry) => {
        if (entry.viAccount === recipient.viAccount) {
          return {
            ...entry,
            isActive,
          };
        } else {
          return entry;
        }
      });

      return {
        ...state,
        notificationRecipientsState: {
          ...state.notificationRecipientsState,
          data: newData,
          errorPUT: null,
        },
      };
    }
  ),

  on(
    NotificationsActions.updateNotificationRecipientError,
    (state, { recipientToRevert, isActiveValue, error }): NotificationsState => {
      const newData = state.notificationRecipientsState.data.map((entry) => {
        if (entry.viAccount === recipientToRevert.viAccount) {
          return {
            ...entry,
            isActive: isActiveValue,
          };
        } else {
          return entry;
        }
      });

      return {
        ...state,
        notificationRecipientsState: {
          ...state.notificationRecipientsState,
          data: newData,
          errorPUT: error,
        },
      };
    }
  )
);
